export class ReWeighMentDefectsModel{
    defectId: number;
    quantity: number;
    percentage:number;
    defectName:string

    constructor(

        defectId:number,
        quantity: number,
        percentage:number,
        defectName:string,
        
    ){
this.defectId=defectId
this.quantity = quantity
this.defectName=defectName
this.percentage=percentage

    }
}